import { Api } from '../../Utils/api'
import { error99, RetAPI, SangriaSuprimento } from '../../Utils/Types'

export const SupSangriaService = {

    Save: async (dados: SangriaSuprimento): Promise<RetAPI> => {
        const resp = await Api("SupSangria/Save", "post", { data: dados.data, valor: dados.valor, observacao: dados.observacao, tipo: dados.tipo })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === "1") {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: '',
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
            }
        }
    }
}